import { render, staticRenderFns } from "./VoltarComp.vue?vue&type=template&id=4d492463&scoped=true&"
import script from "./VoltarComp.vue?vue&type=script&lang=js&"
export * from "./VoltarComp.vue?vue&type=script&lang=js&"
import style0 from "./VoltarComp.vue?vue&type=style&index=0&id=4d492463&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d492463",
  null
  
)

export default component.exports